<div mat-dialog-title class="title-container">
  <h2>{{ 'building.control.title' | transloco }} ({{ 'building.buildingsCount' | transloco : { count } }})</h2>
</div>

@if (control$ | async; as control) {
<mat-dialog-content>
  <sibat-control-report
    [building]="building$ | async"
    [control]="control"
    [hasControlBatchGetPolicy]="hasControlBatchGetPolicy$ | async"
    [offline]="offline$ | async"
    (closeModal)="close()"
  >
  </sibat-control-report>
</mat-dialog-content>
} @else { }

<mat-dialog-actions align="end">
  <sibat-secondary-button class="mat-button-base" (clicked)="close()" [label]="'layout.closeDialog' | transloco"> </sibat-secondary-button>
</mat-dialog-actions>
